
import styled, { css } from "styled-components";

import { colors } from 'pages/Quotes/styles/colors';
import { Row } from "components/Layout/Grid";

interface StatusColorStatusFlowDateProps {
  variant: string | number;
}

const variantColors: Record<string, string> = {
  HEALTH_OPERATOR_WITHOUT_BUY_ORDER: colors.red,
  HEALTH_OPERATOR_INCORRECT_BUY_ORDER: colors.red,
  HEALTH_OPERATOR_WITHOUT_PRODUCT: colors.red,
  ERROR_SENT_INVOICE: colors.red,
  ERROR_SENT_RECEIPT: colors.red,
  PENDING_SEARCH: colors.yellow,
  PENDING_SEND_INVOICE: colors.yellow,
  MANUAL_ACTION_REQUIRED: colors.yellow,
  SENT_INVOICE: colors.yellow,
  PENDING_RECEIPT: colors.yellow,
  CONFIRMED_INVOICE: colors.yellow,
  SENT_RECEIPT: colors.yellow,
  FINISHED: colors.greenDark,
};

export const StatusFlowWrapper = styled.span<StatusColorStatusFlowDateProps>`
  width: 0.5rem;
  height: 0.5rem;

  border-radius: 50%;
  margin-right: 0.625rem;

  ${(props) =>
    variantColors[props.variant] &&
    css`
      background: ${variantColors[props.variant]};
  `}
`;

export const DivStopWatch = styled(Row)`
    gap: 10px;
    font-size: 0.875rem;
    font-style: italic;
    justify-content: end;

    padding-top: 0.938rem;
`;